module.exports = __webpack_public_path__ + "static/media/profile_max.b9a533ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/team/profile_max.png
// module id = 1118
// module chunks = 4